import React from 'react';
import PropTypes from 'prop-types';

const LOAN_STATUS_CONFIG = {
  draft: {
    icon: 'fa-edit',
    color: '#1976d2',
    background: '#e3f2fd',
    label: 'Draft',
    border: '1px solid #1976d2'
  },
  under_review: {
    icon: 'fa-clock',
    color: '#ed6c02',
    background: '#fff3e0',
    label: 'Under Review',
    border: '1px solid #ed6c02'
  },
  approved: {
    icon: 'fa-check-circle',
    color: '#2e7d32',
    background: '#e8f5e9',
    label: 'Approved',
    border: '1px solid #2e7d32'
  },
  rejected: {
    icon: 'fa-times-circle',
    color: '#c62828',
    background: '#ffebee',
    label: 'Rejected',
    border: '1px solid #c62828'
  },
  disbursed: {
    icon: 'fa-money-bill',
    color: '#ed6c02',
    background: '#fff3e0',
    label: 'Disbursed',
    border: '1px solid #ed6c02'
  },
  default: {
    icon: 'fa-exclamation-circle',
    color: '#c62828',
    background: '#ffebee',
    label: 'Default',
    border: '1px solid #c62828'
  },
  cleared: {
    icon: 'fa-check-circle',
    color: '#2e7d32',
    background: '#e8f5e9',
    label: 'Cleared',
    border: '1px solid #2e7d32',
  },
  closed: {
    icon: 'fa-lock-circle',
    color: '#c62828',
    background: '#ffebee',
    label: 'Closed',
    border: '1px solid #c62828'
  },
  info: {
    icon: 'fa-info-circle',
    color: '#2e7d32',
    background: '#e8f5e9',
    label: 'Active',
    border: '1px solid #2e7d32',
  }
};

const BADGE_TYPE_CONFIG = {
  loan: LOAN_STATUS_CONFIG,
}

const StatusBadge = ({ status, type, showLabel = true }) => {
  const config = BADGE_TYPE_CONFIG[type][status.toLowerCase()] || BADGE_TYPE_CONFIG[type].info;
  
  return (
    <span 
      className={'status-badge'}
      style={{
        background: config.background,
        color: config.color,
        border: config.border,
        borderRadius: '16px'
      }}
    >
      <i className={`fas ${config.icon}`}></i>
      {showLabel && config.label}
    </span>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  showLabel: PropTypes.bool
};

export default StatusBadge; 